module.exports = __webpack_public_path__ + "img/baklava.0d62d668.svg";